import * as React from "react";
import { useRouter } from "next/router";

import { UniversalLayout } from "@zapier/universal-layout";
import { useTrackingContext } from "@zapier/toolbox-tracking";

type Props = {
  children: React.ReactNode;
};

export function PageLayout(props: Props) {
  const { trackEvent } = useTrackingContext();
  const router = useRouter();

  return (
    <UniversalLayout currentUrl={router.asPath} trackEvent={trackEvent}>
      <>{props.children}</>
    </UniversalLayout>
  );
}
